import { LandingNavbar } from "../components/Homepage/landing-navbar"
import SummarizationDocs from "../components/SummarizationDocs";

const SummarizationDocsPage = () => {
    return (
    <main className="h-full bg-[#111827] overflow-auto">
        <div className="mx-auto max-w-screen-xl h-full w-full">
            <LandingNavbar />
            <SummarizationDocs />
        </div>
      </main>
    )
}

export default SummarizationDocsPage;